import React from 'react';
import { HiOutlineMoon, HiOutlineSun } from 'react-icons/hi2';
import { useDarkMode } from 'context/DarkModeContext';
import styled from 'styled-components';

const ButtonIcon = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  align-self: center;
  background: none;
  border: none;
  padding: 0.3rem;
  border-radius: 5px;
  line-height: 1;
  cursor: pointer;
  transition: all 0.2s;

  & svg {
    display: block;
    width: 1.7rem;
    height: 1.7rem;
    color: #739bcb;
  }
`;

function DarkModeToggle() {
  const { isDarkMode, toggleDarkMode } = useDarkMode();

  return (
    <ButtonIcon onClick={toggleDarkMode}>
      {isDarkMode ? <HiOutlineSun /> : <HiOutlineMoon />}
    </ButtonIcon>
  );
}

export default DarkModeToggle;
